
import { Component, Watch, Prop, Vue } from 'vue-property-decorator';
import RecipeService, { FullData, Recipe } from '@/services/recipes.service';

@Component
export default class NetWeightPerPackageUnitInput extends Vue {
  @Prop() private model!: Recipe;

  data():any {
      return {
            unitOptions: [
                { value: 'gram', text: 'gramos' },
                { value: 'ml', text: 'mililitros' },
            ]
      }
  }

  updateValue() {
    const value = this.model.net_weight_per_package_unit;
    RecipeService.updateOne(this.model.id, {
        net_weight_per_package_unit: value,
      }).then((data:FullData) => {
            this.$store.commit('updateRecipe', data.label);
            this.$store.commit('updateTable', data.table);
      }).catch(error => {
        console.log(error);
      });
  }
}
